import { NotificationElement } from "../interfaces/notification-element";

export function createNotification(
  partial: Partial<NotificationElement>,
): NotificationElement {
  return {
    id: null,
    content: {
      message: "",
      url: null,
      url_type: "default",
      ...partial.content,
    },
    type: "info",
    created_at: null,
    read_at: null,
    ...partial,
  };
}
